import { Reducer } from '@reduxjs/toolkit';
import { reducer as authReducer, AuthState } from './slices/authSlice';

const rootReducer: () => {
  auth: Reducer<AuthState>;
} = () => ({
  auth: authReducer,
});

export default rootReducer;
